import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Field, reduxForm } from 'redux-form';
import FormTextField from '../../legacyForm/FormTextField';
import { passwordRecoveryFormValidation } from '../../../models/auth/AuthModelValidation';
import './PasswordRecoveryFormStyles.scss';

let PasswordRecoveryForm = ({ handleSubmit, submitting }) => {
  return (
    <form onSubmit={handleSubmit}>
      <div>
        <Field 
          name="email" 
          type="email" 
          component={FormTextField}
          label="Twój adres email"
          fullWidth
        />
      </div>
      <Button variant="contained" color="primary" type="submit" style={{ marginTop: 20 }} disabled={submitting}>
        Wyślij
      </Button>
    </form>
  );
};

PasswordRecoveryForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
};

PasswordRecoveryForm = reduxForm({
  form: 'passwordRecovery',
  validate: passwordRecoveryFormValidation,
})(PasswordRecoveryForm);

export default PasswordRecoveryForm;


// WEBPACK FOOTER //
// ./src/components/budgetAuth/passwordRecovery/PasswordRecoveryForm.js